import type { RequestConfig } from '@customTypes/index';
import axios from 'axios';

type RefreshTokenRequest = {
  refreshToken: string;
};

export type RefreshTokenResponseDto = {
  token: string;
  refreshToken: string;
};

export type RefreshTokenParams = RequestConfig<RefreshTokenRequest>;

export const refreshToken = async ({ params, config }: RefreshTokenParams) =>
  axios.post<RefreshTokenResponseDto>(
    `${import.meta.env.VITE_BASE_URL}/api/account/refresh`,
    params,
    config
  );
